import { useSelector } from 'react-redux';
import { NotificationsSelectors } from '@copilot/common/store/selectors/notifications';
import reduce from 'lodash/reduce';
import { SidebarNotificationMap } from './sideBarTypes';
import { DEFAULT_SIDEBAR_NOTIFICATIONS } from './sideBarConstants';
import { NotificationType } from '@copilot/common/store/models/const/enum';
/**
 * Get the sidebar notifications
 * @returns A map of the sidebar notifications
 */
export function useSidebarNotifications(): SidebarNotificationMap {
    const notifications = useSelector(NotificationsSelectors.getNotifications);
    return reduce(
        notifications,
        (acc: SidebarNotificationMap, notification) => {
            if (notification.id in NotificationType) {
                return { ...acc, [notification.id]: parseInt(notification.body) };
            }
            return acc;
        },
        DEFAULT_SIDEBAR_NOTIFICATIONS
    );
}
